import { useInView } from 'react-intersection-observer'
import React, { useState, useEffect } from 'react'

const LazyLoad = ({ children, initialHeight, height, time }) => {
  const [isRendered, setIsRendered] = useState(false)
  const [wrapperRef, isOnScreen] = useInView({ threshold: 0 })

  useEffect(() => {
    if (isOnScreen && !isRendered) {
      setIsRendered(true)
    }
  }, [isOnScreen])
  return (
    <div ref={wrapperRef} style={{ minHeight: !isRendered && (initialHeight || '10rem'), height }}>
      {isRendered && children}
    </div>
  )
}

export default LazyLoad
